function sektionHatInhalt(s) {
  if (!s) return false;
  if (s.eintraege && typeof s.eintraege === 'object' && !Array.isArray(s.eintraege) && Object.keys(s.eintraege).length > 0) return true;
  if (Array.isArray(s.eintraege) && s.eintraege.length > 0) return true;
  if (Array.isArray(s.werte) && s.werte.length > 0) return true;
  if (Array.isArray(s.kenntnisse) && s.kenntnisse.some(x => String(x).trim())) return true;
  if (Array.isArray(s.bullets) && s.bullets.some(x => String(x).trim())) return true;
  if (typeof s.text === 'string' && s.text.trim().length > 0) return true;
  return false;
}

export function hatLebenslaufInhalt(profil) {
  if (!profil) return false;
  if (Array.isArray(profil.sektionen) && profil.sektionen.length > 0) return true;
  if (profil.berufserfahrung && Object.keys(profil.berufserfahrung).length > 0) return true;
  return false;
}

export function profilAnzeigeName(profil) {
  if (!profil) return '';
  if (profil.vorname && profil.nachname) return `${profil.vorname} ${profil.nachname}`;
  return profil.name || profil.dateiname || '';
}
